export const GET_SUB_SECTIONS = "GET_SUB_SECTIONS";
export const GET_SUB_SECTION_BY_ID = "GET_SUB_SECTION_BY_ID";
export const UPDATE_SUB_SECTION = "UPDATE_SUB_SECTION";
export const DELETE_SUB_SECTION = "DELETE_SUB_SECTION";
export const CREATE_SUB_SECTION = "CREATE_SUB_SECTION";
